import React,{useEffect, useRef, useState} from "react";
import './contactme.css'
import TypeWriterEffect from 'react-typewriter-effect';
import emailjs from '@emailjs/browser';

export default function Contactme(){

    const [isActive, setIsActive] = useState(false);

    const handleClick = event => {
        // 👇️ toggle isActive state on click
        setIsActive(current => !current);
    };

    const form = useRef();

    const sendEmail = (e) => {
        e.preventDefault();

        emailjs.sendForm('myPotiforio', 'template_sjg52ew', form.current, 'Jfezx_kAOMM6ZmU_X')
        .then((result) => {
            console.log(result.text);
            e.target.reset()
            handleClick()
            
        }, (error) => {
            console.log(error.text);
        });
    };

    useEffect(()=>{
        window.scrollTo({top:0, left:0, behavior:'smooth'})
    })
    return(
        <div className="contactme_container container">
            <h1 className="contactme_text">
                    <TypeWriterEffect
                        textStyle={{ 
                            fontSize: '1.5rem',
                            color: 'green'
                        }}
                        cursorColor="green"
                        startDelay={100}
                        text="Contact Me,"
                        typeSpeed={100}
                        hideCursorAfterText={true}
                    />
            </h1>
            <p className="getintouch">
                        <TypeWriterEffect
                            textStyle={{ 
                                fontSize: '1rem',
                                fontWeight:'500'
                            }}
                            cursorColor="white"
                            startDelay={1500}
                            text="Do you have any project that you need collaboration or done for?"
                            typeSpeed={50}
                            hideCursorAfterText={true}
                        />
                
            </p>
            <div className="contactme_details">
                <div className="contactme_col1">
                    <div className="callme_wrapper cwrapper">
                        <p className="callme_text cmtext">Call me</p>
                        <p className="callme_phone ">0880593391</p>
                    </div>

                    <div className="email_wrapper_me cwrapper">
                        <p className="email_text cmtext">Email</p>
                        <p className="email_email">mkalidozo3@gmail.com</p>
                    </div>

                    <div className="location_wrapper cwrapper">
                        <p className="location_text cmtext">Location</p>
                        <p className="location_adress">Malawi, Blantyre</p>
                    </div>
                </div>

                

                <form className="contactme_col2" ref={form} onSubmit={sendEmail}>
                    <div className="name_and_email_container ">
                        <div className="name_wrapper ">
                            <label>Name</label>
                            <input className="text_input" type="text" id="name" name="name" required></input>
                        </div>

                        <div className="email_wrapper ">
                            <label>Email</label>
                            <input className="text_input" type="email" id="email" name="email" required></input>
                        </div>
                    </div>
                    <div className="project_wrapper form_wrapper ">
                        <label>Project</label>
                        <input className="text_input" type="text" id="project" name="project" required></input>
                    </div>

                    <div className="message_wrapper form_wrapper"  required>
                        <label>Message</label>
                        <textarea
                        id="message" 
                        name="message"
                        cols="0"
                        rows="7"
                        className="text_input"
                        ></textarea>
                    </div>
                        
                    <div className="col2_submit_btn">
                        <input className="greenbtn col2_submitbtn" type="submit" name="send" value="Send Message"></input>
                        <p className={isActive ? 'pShow' : 'pHide'}>Message Sent!!</p>
                    </div>
                    
                </form>
                
            </div>
            <p className="contactme_footer">
                Fellow computer enthusiast, i am open for collaborative 
                projects and Video game production. alone we can do so little, together we can do much.
            </p>
        </div>
    )
}